<div class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium text-white" [ngClass]="{
  'bg-green-600': status ? typeTrue === 'success' : typeFalse === 'success',
  'bg-orange-600': status ? typeTrue === 'warning' : typeFalse === 'warning',
  'bg-red-600': status ? typeTrue === 'danger' : typeFalse === 'danger',
  'bg-blue-600': status ? typeTrue === 'info' : typeFalse === 'info',
}">
  <i class="me-3 text-base mr-1 border-white" [innerHTML]="(status ? iconTrue : iconFalse) | feather: { width: 16, height: 16 }"
     [ngClass]="{
        'h-4 w-4': iconSize === 'small',
        'h-8 w-8': iconSize === 'medium',
        'h-12 w-12': iconSize === 'large',
     }"
  ></i>
  @if (status && messageTrue) {
    {{ messageTrue }}
  } @else if (!status && messageFalse) {
    {{ messageFalse }}
  } @else {
    <ng-content></ng-content>
  }
</div>
